import { useState, useEffect, useContext } from 'react';
import { UserContext } from 'contexts/user';

const useEmailCheck = () => {
  const { user } = useContext(UserContext);
  const [emailVerified, setEmailVerified] = useState<boolean>(false);

  useEffect(() => {
    if ((user?.email !== null && user?.verified) ?? false) {
      setEmailVerified(true);
      return;
    }
  }, [user]);

  return emailVerified;
};

export default useEmailCheck;
